// Components
import { Creatable, CreatableWithTags } from '../../../molecules/advancedSelect';

// Containers
import withSelectInput from '../hoc/withSelectInput';
export var CreatableSelectWithTags = withSelectInput(CreatableWithTags);
export default withSelectInput(Creatable, {
  useFilterOption: false
});